import React, { useEffect, useState, useContext } from "react";
import NavBar from "./components/NavBar";
import DashBorder from "./pages/DashBoard";
import './css/dashboard.css'
import './css/nav.css'
import './css/transfer.css'
import './css/beneficiary-popup.css'
import './css/investt.css'
import './css/beneficiaries.css'
import './css/transaction.css'
import './css/accoutstate.css'
import './css/bills.css'
import './css/setting.css'
import './css/settings2.css'
import './css/animations.css'


import { styled } from '@mui/system'
import { Theme } from "@mui/material";
import ReceiveFundsPopup from "./pages/ReceiveFunds";
import Transfer from "./pages/Transfer";
import BeneficiariesPopup from "./components/BeneficiariesPopup";
import BeneficiariesOtherPopup from "./components/BeneficiariesOthers";
import Invest from "./pages/Invest";
import Beneficiaries from "./pages/BeneficiariesPage";
import AddBeneficiairyPopup from "./components/AddBeneficairyPopup";
import Transaction from "./pages/Transactions";
import TransactionDetailPopup from "./components/TransactionDetailPopup";
import AccountStatement from "./pages/AccoutStatement";
import BillManagement from "./pages/BillManage";
import BillsPayment from "./pages/BillsPayment";
import BillsPaymentFrom from "./components/BillsPaymentForm";
import Settings from "./pages/Settings";
import SettingsProfile from "./pages/SettingProfile";
import SettingAccountManagement from "./pages/SettingAccountManagement";
import SettingLegal from "./pages/SettingLegal";
import SettingHelp from "./pages/SettingHelp";
import SomethingWrongPopup from "./components/SomethingWrongPopup";
import LimitTranscation from "./components/LimitTranscation";
import EnterPin from "./components/EnterPin";
import ChangePin from "./components/ChangePin";
import ResetPin from "./components/ResetPin";
import InvestNew from "./pages/InvestNew";

import axios from 'axios';
import SelectAccountPopup from "./components/SelectAccountPopup";
import TransferProcessingPopup from "./components/TransferProcessing";
import {FirebaseContext} from "../../context/firebase";


interface Props {
    name: string
    settingName: string
}

const Layout: React.FC<Props>=({name, settingName})=>{
    const { data, error, loadingGettingUserData, refresh } = useContext(FirebaseContext);

    const [user, setUser] = useState(data)
    const [transferActiveBeneficiary, setTransferActiveBeneficiary] = useState<string>("Choose Beneficiary")
    const [transferActiveBeneficiary2, setTransferActiveBeneficiary2] = useState<string>("Choose Beneficiary")
    const [transferActiveBeneficiary3, setTransferActiveBeneficiary3] = useState<string>("Choose Beneficiary")
    const accountType = data.accountType
    const accountNumber = data.accountPatial
    const accountBalance = data.balance
    const stringCont = `${accountType} ${accountNumber}  –  ${accountBalance}`
    const [transferActiveBeneficiary4, setTransferActiveBeneficiary4] = useState<string>(stringCont)

    const [dropdown, setDropdown] = useState<string>("")
    const [dropdownOpt1, setDropdownOpt1] = useState<string>("")
    const [dropdownOpt2, setDropdownOpt2] = useState<string>("")
    const [wrongAccountNumber, setWrongAccountNumber] = useState(false)
    const [networkError, setNetworkErrror] = useState(false)
    const [loading, setLoading] = useState(false)
    const [wrongAccountNumber2, setWrongAccountNumber2] = useState(false)
    const [networkError2, setNetworkErrror2] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [transactionDetailsActiveItem, setTransactionDetailsActiveItem] = useState<any>({})

    const [transferProcessingActive, setTransferProcessingActive] = useState<boolean>(false)
    const [transferProcessingDay2, setTransferProcessingDay2] = useState<number>(14)

    const transactionProcessingClose =()=>{
        setTransferProcessingActive(false)
    }

    
    const checkAccountNumber = ()=>{
        setLoading(true)
        setWrongAccountNumber(false)
        setNetworkErrror(false)
        axios.get(process.env.REACT_APP_PRODUCT_ENDPOINT || '')
        .then(function (response) {
            // handle success
            setNetworkErrror(false)
            setLoading(false)
            setWrongAccountNumber(true)
            setTransferActiveBeneficiary("Choose Beneficiary")
        })
        .catch(function (error) {
            // handle error
            setNetworkErrror(true)
            setLoading(false)
            setWrongAccountNumber(false)
            setTransferActiveBeneficiary("Choose Beneficiary")
        })
    }

    const checkAccountNumber2 = ()=>{
            setLoading2(true)
            setWrongAccountNumber2(false)
            setNetworkErrror2(false)
            axios.get(process.env.REACT_APP_PRODUCT_ENDPOINT || '')
            .then(function (response) {
                // handle success
                setNetworkErrror2(false)
                setLoading2(false)
                setWrongAccountNumber2(true)
            })
            .catch(function (error) {
                // handle error
                setNetworkErrror2(true)
                setLoading2(false)
                setWrongAccountNumber2(false)
            })
    }

    const handleECCUOption1 =()=>{
        document.getElementById('transfer-option-3')?.classList.remove('active')
        document.getElementById('transfer-option-2')?.classList.remove('active')
        document.getElementById('transfer-option-1')?.classList.add('active')

        document.getElementById('groom-panel-active-option-3')?.classList.remove('active')
        document.getElementById('groom-panel-active-option-2')?.classList.remove('active')
        document.getElementById('groom-panel-active-option-1')?.classList.add('active')
    }

    const handleOthersOption2 =()=>{
        document.getElementById('transfer-option-3')?.classList.remove('active')
        document.getElementById('transfer-option-1')?.classList.remove('active')
        document.getElementById('transfer-option-2')?.classList.add('active')

        document.getElementById('groom-panel-active-option-3')?.classList.remove('active')
        document.getElementById('groom-panel-active-option-1')?.classList.remove('active')
        document.getElementById('groom-panel-active-option-2')?.classList.add('active')
    }

    const handleOthersOption3 =()=>{
        document.getElementById('transfer-option-1')?.classList.remove('active')
        document.getElementById('transfer-option-2')?.classList.remove('active')
        document.getElementById('transfer-option-3')?.classList.add('active')

        document.getElementById('groom-panel-active-option-1')?.classList.remove('active')
        document.getElementById('groom-panel-active-option-2')?.classList.remove('active')
        document.getElementById('groom-panel-active-option-3')?.classList.add('active')
    }
    

    

    useEffect(()=> {
        document.title = "Dashboard"
    }, [])
    

    const handleNavClose=()=>{
        const element2 = document.getElementById('sidebar')
        element2?.classList.add('active')

        const element = document.getElementById('small-nav-overlay')
        element?.classList.add('active')
    }
    const handleHideBalance = () =>{
        const h2el = document.getElementById('hideH2')
        if(h2el?.innerText === '$XXX.XXX'){
            h2el.innerText = user.balance
        }else{
            h2el!.innerText = '$XXX.XXX'
        }


        const h4el = document.getElementById('hideH4')
        if(h4el?.innerText === '$XXX.XXX'){
            h4el.innerText = user.balance
        }else{
            h4el!.innerText = '$XXX.XXX'
        }

        const hideBalance = document.getElementById('hideBalanceSpan')
        if(hideBalance?.innerText === 'Hide Balance'){
            hideBalance.innerText = 'Show Balance'
        }else{
            hideBalance!.innerText = 'Hide Balance'
        }

        
    }

    const handleTopupOpen =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-receive-funds')
        sidebarEl?.classList.add('show')
    }
    const handleTopupClose =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-receive-funds')
        sidebarEl?.classList.remove('show')
    }

    const handleBeneficiaryOpen =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-beneficiaries-popup')
        sidebarEl?.classList.add('show')
    }
    const handleBeneficiaryClose =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-beneficiaries-popup')
        sidebarEl?.classList.remove('show')
    }



    const handleBeneficiaryOpen2 =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-beneficiaries-popup2')
        sidebarEl?.classList.add('show')
    }
    const handleBeneficiaryClose2 =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-beneficiaries-popup2')
        sidebarEl?.classList.remove('show')
    }


    const handleBeneficiaryOpen3 =()=>{
        const sidebarEl = document.getElementById('ben-beneficiaries-popup')
        sidebarEl?.classList.add('show')
    }
    const handleBeneficiaryClose3 =()=>{
        const sidebarEl = document.getElementById('ben-beneficiaries-popup')
        sidebarEl?.classList.remove('show')
    }

    const handleBeneficiaryOpen4 =()=>{
        const sidebarEl = document.getElementById('transaction-detail-popup')
        sidebarEl?.classList.add('show')
    }
    const handleBeneficiaryClose4 =()=>{
        const sidebarEl = document.getElementById('transaction-detail-popup')
        sidebarEl?.classList.remove('show')
    }

    const handleSelectAccountOpen =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-beneficiaries-popup5')
        sidebarEl?.classList.add('show')
    }

    const handleSelectAccountPopupClose =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-beneficiaries-popup5')
        sidebarEl?.classList.remove('show')
    }

    const handleLimitTransactionOpen =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-limit-transacation')
        sidebarEl?.classList.add('show')
    }
    const handleLimitTransactionClose =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-limit-transacation')
        sidebarEl?.classList.remove('show')
    }

    const handleEnterPinOpen =()=>{
        handleLimitTransactionClose()

        const sidebarEl = document.getElementById('sidebar-wrapper-enter-pin')
        sidebarEl?.classList.add('show')
    }
    const handleEnterPinClose =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-enter-pin')
        sidebarEl?.classList.remove('show')
    }


    const handleEnterPinForInternationTransactionOpen =()=>{
        handleLimitTransactionClose()

        const sidebarEl = document.getElementById('sidebar-wrapper-enter-pin-for-internation-transaction')
        sidebarEl?.classList.add('show')
    }
    const handleEnterPinForInternationTransactionClose =()=>{
        const sidebarEl = document.getElementById('sidebar-wrapper-enter-pin-for-internation-transaction')
        sidebarEl?.classList.remove('show')
    }
    

    const handleDropDownUtilityProviderOpen =()=>{
        // setDropdown("utility-provider")

        document.getElementById('bill-select-utility-type')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-utility-provider')?.classList.add('justdisplaynone')


        document.getElementById('bill-select-utility-type-options')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-utility-provider-options')?.classList.add('justdisplaynone')


        const sidebarEl = document.getElementById('utilities-dropdown-select-popup')
        sidebarEl?.classList.add('show')
    }
    const handleDropDownUtilityServiceProviderOpen =()=>{
        // setDropdown("service-provider")

        document.getElementById('bill-select-utility-type')?.classList.add('justdisplaynone')
        document.getElementById('bill-select-utility-provider')?.classList.remove('justdisplaynone')

        document.getElementById('bill-select-utility-type-options')?.classList.add('justdisplaynone')
        document.getElementById('bill-select-utility-provider-options')?.classList.remove('justdisplaynone')


        const sidebarEl = document.getElementById('utilities-dropdown-select-popup')
        sidebarEl?.classList.add('show')
    }
    const handleDropDownClose =()=>{
        // setDropdown('')

        document.getElementById('bill-select-utility-type')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-utility-provider')?.classList.remove('justdisplaynone')

        document.getElementById('bill-select-utility-type-options')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-utility-provider-options')?.classList.remove('justdisplaynone')

        const sidebarEl = document.getElementById('utilities-dropdown-select-popup')
        sidebarEl?.classList.remove('show')
    }

    const handleDropDownTelecomProviderOpen =()=>{
        // setDropdown("utility-provider")

        document.getElementById('bill-select-telecom-type')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-telecom-provider')?.classList.add('justdisplaynone')


        document.getElementById('bill-select-telecom-type-options')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-telecom-provider-options')?.classList.add('justdisplaynone')


        const sidebarEl = document.getElementById('telecome-dropdown-select-popup')
        sidebarEl?.classList.add('show')
    }
    const handleDropDownTelecomServiceProviderOpen =()=>{
        // setDropdown("service-provider")

        document.getElementById('bill-select-telecom-type')?.classList.add('justdisplaynone')
        document.getElementById('bill-select-telecom-provider')?.classList.remove('justdisplaynone')

        document.getElementById('bill-select-telecom-type-options')?.classList.add('justdisplaynone')
        document.getElementById('bill-select-telecom-provider-options')?.classList.remove('justdisplaynone')


        const sidebarEl = document.getElementById('telecome-dropdown-select-popup')
        sidebarEl?.classList.add('show')
    }
    const handleTelecomDropDownClose =()=>{
        // setDropdown('')

        document.getElementById('bill-select-telecom-type')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-telecom-provider')?.classList.remove('justdisplaynone')

        document.getElementById('bill-select-telecom-type-options')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-telecom-provider-options')?.classList.remove('justdisplaynone')

        const sidebarEl = document.getElementById('telecome-dropdown-select-popup')
        sidebarEl?.classList.remove('show')
    }

    const handleDropDownCableProviderOpen =()=>{
        // setDropdown("utility-provider")

        document.getElementById('bill-select-cable-type')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-cable-provider')?.classList.add('justdisplaynone')


        document.getElementById('bill-select-cable-type-options')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-cable-provider-options')?.classList.add('justdisplaynone')


        const sidebarEl = document.getElementById('cable-dropdown-select-popup')
        sidebarEl?.classList.add('show')
    }
    const handleDropDownCableServiceProviderOpen =()=>{
        // setDropdown("service-provider")

        document.getElementById('bill-select-cable-type')?.classList.add('justdisplaynone')
        document.getElementById('bill-select-cable-provider')?.classList.remove('justdisplaynone')

        document.getElementById('bill-select-cable-type-options')?.classList.add('justdisplaynone')
        document.getElementById('bill-select-cable-provider-options')?.classList.remove('justdisplaynone')


        const sidebarEl = document.getElementById('cable-dropdown-select-popup')
        sidebarEl?.classList.add('show')
    }
    const handleCableDropDownClose =()=>{
        // setDropdown('')

        document.getElementById('bill-select-cable-type')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-cable-provider')?.classList.remove('justdisplaynone')

        document.getElementById('bill-select-cable-type-options')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-cable-provider-options')?.classList.remove('justdisplaynone')

        const sidebarEl = document.getElementById('cable-dropdown-select-popup')
        sidebarEl?.classList.remove('show')
    }

    const handleDropDownCustomProviderOpen =()=>{
        // setDropdown("utility-provider")

        document.getElementById('bill-select-custom-type')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-custom-provider')?.classList.add('justdisplaynone')


        document.getElementById('bill-select-custom-type-options')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-custom-provider-options')?.classList.add('justdisplaynone')


        const sidebarEl = document.getElementById('custom-dropdown-select-popup')
        sidebarEl?.classList.add('show')
    }
    const handleDropDownCustomServiceProviderOpen =()=>{
        // setDropdown("service-provider")

        document.getElementById('bill-select-custom-type')?.classList.add('justdisplaynone')
        document.getElementById('bill-select-custom-provider')?.classList.remove('justdisplaynone')

        document.getElementById('bill-select-custom-type-options')?.classList.add('justdisplaynone')
        document.getElementById('bill-select-custom-provider-options')?.classList.remove('justdisplaynone')


        const sidebarEl = document.getElementById('custom-dropdown-select-popup')
        sidebarEl?.classList.add('show')
    }
    const handleCustomDropDownClose =()=>{
        // setDropdown('')

        document.getElementById('bill-select-custom-type')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-custom-provider')?.classList.remove('justdisplaynone')

        document.getElementById('bill-select-custom-type-options')?.classList.remove('justdisplaynone')
        document.getElementById('bill-select-custom-provider-options')?.classList.remove('justdisplaynone')

        const sidebarEl = document.getElementById('custom-dropdown-select-popup')
        sidebarEl?.classList.remove('show')
    }


    const addSomethingWrong =()=>{
        document.getElementById('somethingwrong')?.classList.add('somethingwrong')
    }
    const removeSomethingWrong =()=>{
        document.getElementById('somethingwrong')?.classList.remove('somethingwrong')
    }
    const lunchSomethingWrong =()=>{
        setTimeout(addSomethingWrong, 1000)
        setTimeout(removeSomethingWrong, 4200)
    }


    const addSomethingWrong2 =()=>{
        document.getElementById('somethingwrong2')?.classList.add('somethingwrong')
    }
    const removeSomethingWrong2 =()=>{
        document.getElementById('somethingwrong2')?.classList.remove('somethingwrong')
    }
    const lunchSomethingWrong2 =()=>{
        setTimeout(addSomethingWrong2, 1000)
        setTimeout(removeSomethingWrong2, 4200)
    }


    const addSomethingWrong3 =()=>{
        document.getElementById('somethingwrong3')?.classList.add('somethingwrong')
    }
    const removeSomethingWrong3 =()=>{
        document.getElementById('somethingwrong3')?.classList.remove('somethingwrong')
    }
    const lunchSomethingWrong3 =()=>{
        setTimeout(addSomethingWrong3, 1000)
        setTimeout(removeSomethingWrong3, 4200)
    }

    const addSomethingWrong4 =()=>{
        document.getElementById('somethingwrong4')?.classList.add('somethingwrong')
    }
    const removeSomethingWrong4 =()=>{
        document.getElementById('somethingwrong4')?.classList.remove('somethingwrong')
    }
    const lunchSomethingWrong4 =()=>{
        setTimeout(addSomethingWrong4, 1000)
        setTimeout(removeSomethingWrong4, 4200)
    }

    const addSomethingWrong5 =()=>{
        document.getElementById('somethingwrong5')?.classList.add('somethingwrong')
    }
    const removeSomethingWrong5 =()=>{
        document.getElementById('somethingwrong5')?.classList.remove('somethingwrong')
    }
    const lunchSomethingWrong5 =()=>{
        setTimeout(addSomethingWrong5, 1000)
        setTimeout(removeSomethingWrong5, 4200)
    }


    const handleChangePinOpen =()=>{
        document.getElementById('sidebar-wrapper-change-pin-setting')?.classList.add('show')
    }
    const handleChangePinClose =()=>{
        document.getElementById('sidebar-wrapper-change-pin-setting')?.classList.remove('show')
    }

    const handleResetPinOpen =()=>{
        document.getElementById('sidebar-wrapper-Reset-Pin')?.classList.add('show')
    }
    const handleResetPinClose =()=>{
        document.getElementById('sidebar-wrapper-Reset-Pin')?.classList.remove('show')
    }


    return (

        <main>
            <NavBar namefromApp={name} handleTopupOpen={handleTopupOpen}  handleNavClose={handleNavClose}></NavBar>

            <div>
                {
                    name === 'home'
                    ?
                    <DashBorder handleHideBalance={handleHideBalance} handleTopupOpen={handleTopupOpen}/>
                    :
                    name === 'manage-bills'
                    ?
                    <BillManagement />
                    :
                    name === 'pay-bills'
                    ?
                    <BillsPayment />
                    :
                    name === 'send-money'
                    ?
                    <Transfer 
                        handleBeneficiaryOpen={handleBeneficiaryOpen} 
                        handleBeneficiaryOpen2={handleBeneficiaryOpen2} 
                        handleSelectAccountOpen={handleSelectAccountOpen}
                        transferActiveBeneficiary={transferActiveBeneficiary}
                        transferActiveBeneficiary2={transferActiveBeneficiary2}
                        transferActiveBeneficiary3={transferActiveBeneficiary3}
                        transferActiveBeneficiary4={transferActiveBeneficiary4}
                        wrongAccountNumber={wrongAccountNumber}
                        networkError={networkError}
                        loading={loading}
                        wrongAccountNumber2={wrongAccountNumber2}
                        networkError2={networkError2}
                        loading2={loading2}
                        checkAccountNumber={checkAccountNumber}
                        checkAccountNumber2={checkAccountNumber2}
                        handleECCUOption1={handleECCUOption1}
                        handleOthersOption2={handleOthersOption2}
                        handleOthersOption3={handleOthersOption3}
                        setTransferProcessingActive={setTransferProcessingActive}
                        handleEnterPinForInternationTransactionOpen={handleEnterPinForInternationTransactionOpen}
                        handleEnterPinForInternationTransactionClose={handleEnterPinForInternationTransactionClose}
                        lunchSomethingWrong={lunchSomethingWrong5}
                    />
                    :
                    name === 'invest'
                    ?
                    <Invest />
                    :
                    name === 'invest-new'
                    ?
                    <InvestNew handleEnterPinOpen={handleEnterPinOpen} handleEnterPinClose={handleEnterPinClose}/>
                    :
                    name === 'beneficiaries'
                    ?
                    <Beneficiaries 
                        handleBeneficiaryOpen3={handleBeneficiaryOpen3} 
                        handleEnterPinOpen={handleEnterPinOpen} 
                        setTransferActiveBeneficiary={setTransferActiveBeneficiary} 
                        setTransferActiveBeneficiary2={setTransferActiveBeneficiary2}
                        setTransferActiveBeneficiary3={setTransferActiveBeneficiary3}

                        handleECCUOption1={handleECCUOption1}
                        handleOthersOption2={handleOthersOption2}
                        handleOthersOption3={handleOthersOption3}
                    />
                    :
                    name === 'transaction-history'
                    ?
                    <Transaction handleBeneficiaryOpen4={handleBeneficiaryOpen4} setTransactionDetailsActiveItem={setTransactionDetailsActiveItem}/>
                    :
                    name === 'account-statement'
                    ?
                    <AccountStatement handleBeneficiaryOpen4={handleBeneficiaryOpen4} lunchSomethingWrong4={lunchSomethingWrong4} lunchSomethingWrong5={lunchSomethingWrong5} handleEnterPinOpen={handleEnterPinOpen}/>
                    :
                    name === 'pay-bills-utilities'
                    ?
                    <BillsPaymentFrom 
                        billType={"pay-bills-utilities"} 
                        handleDropDownProviderOpen={handleDropDownUtilityProviderOpen} 
                        dropdownOpt1={dropdownOpt1} 
                        handleDropDownServiceProviderOpen={handleDropDownUtilityServiceProviderOpen}
                        dropdownOpt2={dropdownOpt2}
                        dropdown={dropdown} 
                        handleDropDownClose={handleDropDownClose} 
                        setDropdownOpt1={setDropdownOpt1}
                        setDropdownOpt2={setDropdownOpt2}
                    />
                    :
                    name === 'pay-bills-telecom'
                    ?
                    <BillsPaymentFrom 
                        billType={"pay-bills-telecom"} 
                        handleDropDownProviderOpen={handleDropDownTelecomProviderOpen} 
                        dropdownOpt1={dropdownOpt1} 
                        handleDropDownServiceProviderOpen={handleDropDownTelecomServiceProviderOpen}
                        dropdownOpt2={dropdownOpt2}
                        dropdown={dropdown} 
                        handleDropDownClose={handleTelecomDropDownClose} 
                        setDropdownOpt1={setDropdownOpt1}
                        setDropdownOpt2={setDropdownOpt2}
                    />
                    :
                    name === 'pay-bills-cable-tv'
                    ?
                    <BillsPaymentFrom 
                        billType={"pay-bills-cable-tv"} 
                        handleDropDownProviderOpen={handleDropDownCableProviderOpen} 
                        dropdownOpt1={dropdownOpt1} 
                        handleDropDownServiceProviderOpen={handleDropDownCableServiceProviderOpen}
                        dropdownOpt2={dropdownOpt2}
                        dropdown={dropdown} 
                        handleDropDownClose={handleCableDropDownClose} 
                        setDropdownOpt1={setDropdownOpt1}
                        setDropdownOpt2={setDropdownOpt2}
                    />
                    :
                    name === 'pay-bills-housing'
                    ?
                    <BillsPaymentFrom 
                        billType={"pay-bills-housing"} 
                        handleDropDownProviderOpen={handleDropDownUtilityProviderOpen} 
                        dropdownOpt1={dropdownOpt1} 
                        handleDropDownServiceProviderOpen={handleDropDownUtilityServiceProviderOpen}
                        dropdownOpt2={dropdownOpt2}
                        dropdown={dropdown} 
                        handleDropDownClose={handleDropDownClose} 
                        setDropdownOpt1={setDropdownOpt1}
                        setDropdownOpt2={setDropdownOpt2}
                    />
                    :
                    name === 'pay-bills-loan'
                    ?
                    <BillsPaymentFrom 
                        billType={"pay-bills-loan"} 
                        handleDropDownProviderOpen={handleDropDownUtilityProviderOpen} 
                        dropdownOpt1={dropdownOpt1} 
                        handleDropDownServiceProviderOpen={handleDropDownUtilityServiceProviderOpen}
                        dropdownOpt2={dropdownOpt2}
                        dropdown={dropdown} 
                        handleDropDownClose={handleDropDownClose} 
                        setDropdownOpt1={setDropdownOpt1}
                        setDropdownOpt2={setDropdownOpt2}
                    />
                    :
                    name === 'pay-bills-subscription'
                    ?
                    <BillsPaymentFrom 
                        billType={"pay-bills-subscription"} 
                        handleDropDownProviderOpen={handleDropDownUtilityProviderOpen} 
                        dropdownOpt1={dropdownOpt1} 
                        handleDropDownServiceProviderOpen={handleDropDownUtilityServiceProviderOpen}
                        dropdownOpt2={dropdownOpt2}
                        dropdown={dropdown} 
                        handleDropDownClose={handleDropDownClose} 
                        setDropdownOpt1={setDropdownOpt1}
                        setDropdownOpt2={setDropdownOpt2}
                    />
                    :
                    name === 'pay-bills-custom'
                    ?
                    <BillsPaymentFrom 
                        billType={"pay-bills-custom"} 
                        handleDropDownProviderOpen={handleDropDownCustomProviderOpen} 
                        dropdownOpt1={dropdownOpt1} 
                        handleDropDownServiceProviderOpen={handleDropDownCustomServiceProviderOpen}
                        dropdownOpt2={dropdownOpt2}
                        dropdown={dropdown} 
                        handleDropDownClose={handleCustomDropDownClose} 
                        setDropdownOpt1={setDropdownOpt1}
                        setDropdownOpt2={setDropdownOpt2}
                    />
                    :
                    name === 'settings' && settingName === 'setting-profile'
                    ?
                    <SettingsProfile />
                    :
                    name === 'settings' && settingName === 'account-management'
                    ?
                    <SettingAccountManagement 
                        lunchSomethingWrong={lunchSomethingWrong} 
                        lunchSomethingWrong2={lunchSomethingWrong2} 
                        lunchSomethingWrong3={lunchSomethingWrong3}
                        lunchSomethingWrong5={lunchSomethingWrong5} 
                        handleLimitTransactionOpen={handleLimitTransactionOpen}
                        handleChangePinOpen={handleChangePinOpen}
                        handleResetPinOpen={handleResetPinOpen}
                    />
                    :
                    name === 'settings' && settingName === 'legal'
                    ?
                    <SettingLegal />
                    :
                    name === 'settings' && settingName === 'help'
                    ?
                    <SettingHelp />
                    :
                    null
                }
            </div>
            


            <ReceiveFundsPopup handleTopupClose={handleTopupClose}/>
            <BeneficiariesPopup 
                handleBeneficiaryClose={handleBeneficiaryClose} 
                setTransferActiveBeneficiary={setTransferActiveBeneficiary}
                checkAccountNumber={checkAccountNumber}
            />
            <BeneficiariesOtherPopup 
                handleBeneficiaryClose2={handleBeneficiaryClose2}
                setTransferActiveBeneficiary2={setTransferActiveBeneficiary2}
                checkAccountNumber2={checkAccountNumber2}
            />
            <AddBeneficiairyPopup handleBeneficiaryClose3={handleBeneficiaryClose3} lunchSomethingWrong5={lunchSomethingWrong5} handleEnterPinOpen={handleEnterPinOpen}/>
            <TransactionDetailPopup handleBeneficiaryClose4={handleBeneficiaryClose4} transactionDetailsActiveItem={transactionDetailsActiveItem}/>
            <LimitTranscation handleLimitTransactionClose={handleLimitTransactionClose} handleEnterPinOpen={handleEnterPinOpen}/>
            <EnterPin handleEnterPinClose={handleEnterPinClose} lunchSomethingWrong={lunchSomethingWrong5}/>
            <ChangePin handleChangePinClose={handleChangePinClose} lunchSomethingWrong={lunchSomethingWrong5}/>
            <ResetPin handleResetPinClose={handleResetPinClose}/>
            <SomethingWrongPopup />
            <SelectAccountPopup 
                handleSelectAccountPopupClose={handleSelectAccountPopupClose} 
                setTransferActiveBeneficiary={setTransferActiveBeneficiary}
                checkAccountNumber={checkAccountNumber}
            />
            <TransferProcessingPopup 
                transferProcessingActive={transferProcessingActive} 
                transactionProcessingClose={transactionProcessingClose}  
                transferProcessingDay2={transferProcessingDay2}
            />

            <div id="small-nav-overlay" onClick={handleNavClose}>
                <button onClick={handleNavClose} type="button" id="toggleSideNav" className="btn btn-close" aria-label="Close"><span aria-hidden="true">×</span></button>
            </div>

        </main>
            
    )
}

export default Layout